import { Skeleton } from '@mantine/core'

/**
 * Layout-family skeleton for table destinations (ADR 0027): a toolbar row plus shimmering
 * body rows, holding a table's shape while its route loader (or first fetch) is in flight.
 */
export function DataTableSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div
      data-testid="data-table-loading"
      role="status"
      aria-busy="true"
      aria-label="Loading table"
      style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem', padding: '1rem' }}
    >
      <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.5rem' }}>
        <Skeleton height={32} width="14rem" radius="var(--radius-sm)" />
        <Skeleton height={32} width="8rem" radius="var(--radius-sm)" />
        <Skeleton height={32} width="8rem" radius="var(--radius-sm)" style={{ marginLeft: 'auto' }} />
      </div>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={36} radius="var(--radius-sm)" />
      ))}
    </div>
  )
}
